import { css } from "@emotion/react";
import Link from "next/link";
import { useRouter } from "next/router";

import CreateAccountLead from "~/components/common/CreateAccountLead";
import { FormResponseArea } from "~/components/quest/detail/FormResponseArea";
import ImageResponseArea from "~/components/quest/detail/ImageResponseArea";
import {
  Props,
  useConvertMarkdownToHtml,
} from "~/components/quest/page/[id]/lib";
import { useGraphqlClientWithAuth } from "~/lib/client/hooks/useGraphqlClient";
import { useAppContext } from "~/pages/_app";

export const QuestTaskView = ({
  quest,
  questTask,
  setCompleteQuestTask,
}: {
  quest: Props["quest"];
  questTask: Props["quest"]["questTasks"][number];
  setCompleteQuestTask: (questTaskId: number) => void;
}) => {
  const router = useRouter();
  const client = useGraphqlClientWithAuth();
  const questTaskDescription = useConvertMarkdownToHtml(questTask.description);
  const { currentUser } = useAppContext();

  const form = questTask.form;

  return (
    <div key={questTask.id} css={rootStyle}>
      <h2>{questTask.title}</h2>
      {form && (
        <p>
          投稿先：
          <Link href={`/database/${form.id}`}>{form.title}</Link>
        </p>
      )}
      <details>
        <summary>ヒント</summary>
        <p dangerouslySetInnerHTML={{ __html: questTaskDescription }} />
        {questTask.url && <Link href={questTask.url}>{questTask.url}</Link>}
      </details>
      {currentUser == null && (
        <CreateAccountLead
          label={"アカウントを作成してクエストを進めましょう"}
          redirectPath={router.asPath}
        />
      )}
      {client &&
        (form ? (
          <FormResponseArea
            client={client}
            quest={quest}
            questTask={questTask}
            form={form}
            setCompleteQuestTask={setCompleteQuestTask}
          />
        ) : (
          <ImageResponseArea
            client={client}
            quest={quest}
            questTask={questTask}
            setCompleteQuestTask={setCompleteQuestTask}
          />
        ))}
    </div>
  );
};

const rootStyle = css`
  margin-top: 32px;
  counter-increment: section;

  h2 {
    margin: 0;

    ::before {
      content: "STEP " counter(section) ". ";
      margin-right: 8px;
    }
  }

  details {
    margin: 16px 0;
    padding: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  a {
    text-decoration: underline;
  }
`;
